import * as React from 'react'
import {formatDate} from "@ui-seeker/utils";

import {NotAllowedBlock} from "@components";
import {Typography} from "@mui/material";


export default function streetDateColumn() {
    return {
        name: 'deliveryInfo',
        label: 'Delivery Info',
        options: {
            headerAlign: 'left',
            customBodyRowRender: value => {
                if (!value) return <NotAllowedBlock />
                return <Typography>{value}</Typography>
            }
        }
    }
}